import { PaginatedResponse } from './common';

export type AuthorizedTeammate = {
  uuid: string;
  bankAccountId: string;
  teammateId: string;
  teammateFirstName: string;
  teammateLastName: string;
  teammateEmail: string;
  authorizedAt: string;
};

export type AuthorizedTeammateListResponse =
  PaginatedResponse<AuthorizedTeammate>;

export type AuthorizedTeammateListQueryParams = {
  page: number;
  bank_account_id: string;
  records_per_page?: number;
};

export const queryKeys = {
  list: ['authorizedTeammatesList'] as const,
};
